import { cn } from '@/lib/utils';

interface BookingCodeLinkProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  bookingCode: string;
}

/**
 * Sygnatura rezerwacji jako odsyłacz. Nawigację obsługuje ekran nadrzędny —
 * widoki modułu są prezentacyjne, więc dostają callback zamiast trasy.
 */
export const BookingCodeLink = ({
  bookingCode,
  className,
  ...props
}: BookingCodeLinkProps) => (
  <button
    type="button"
    className={cn(
      'cursor-pointer font-semibold text-info-300 underline-offset-2 hover:underline',
      className,
    )}
    {...props}
  >
    {bookingCode}
  </button>
);

interface CrossLinkRowProps extends React.HTMLAttributes<HTMLDivElement> {
  actionLabel: string;
  onAction: () => void;
}

/**
 * Linia odsyłająca na sąsiedni ekran — stoi na dole ekranu uczestnika
 * („Raty i wpłaty →") i zapisującego („Otwórz rezerwację →"). Obie mówią to
 * samo: reszta rozliczenia mieszka na poziomie rezerwacji.
 */
const CrossLinkRow = ({
  actionLabel,
  onAction,
  children,
  className,
  ...props
}: CrossLinkRowProps) => (
  <div
    className={cn(
      'flex flex-wrap items-center justify-between gap-x-5 gap-y-3',
      className,
    )}
    {...props}
  >
    <span className="text-sm text-neutral-500">{children}</span>
    <button
      type="button"
      onClick={onAction}
      className="shrink-0 cursor-pointer rounded-lg border border-neutral-200 bg-basic-white px-[13px] py-[7px] text-sm font-semibold text-neutral-800 transition-colors hover:border-neutral-500"
    >
      {actionLabel}
    </button>
  </div>
);

export default CrossLinkRow;
